import { Component, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { ApiService } from '@core/services/api.service';
import { ErrorService } from '@core/services/error.service';
import { LoginService } from '@core/services/login.service';
import { StoreService } from '@core/services/store.service';
import { GtmService } from '@core/services/gtm.service';
import { List } from '@shared/interfaces/list';
import { Error } from '@shared/interfaces/error';
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, finalize, take } from 'rxjs/operators';
import { TAppService } from '@core/services/t-app.service';
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.styl'],
})
export class ListComponent implements OnInit {
  url: string;
  list: List;
  error: Error;
  urlParams: any = {};

  cdnPath: string;
  domainPath:string;

  public isListLoading$: BehaviorSubject<boolean> = new BehaviorSubject(true);

  constructor(
    private apiService: ApiService,
    private loginService: LoginService,
    private storeService: StoreService,
    private gtmService: GtmService,
    private errorService: ErrorService,
    private tAppService:TAppService
  ) { }

  ngOnInit(): void {
    this.url = window.location.href;
    // 環境変数とくじIDからCDNパスを作成
    this.cdnPath = environment.cdnPath;
    this.domainPath = environment.domainPath;
    this.urlParams = this.storeService.get('urlParams');

    this.apiService.post('/list', this.urlParams)
    .pipe(
      take(1),
      finalize(() => this.isListLoading$.next(false)),
      catchError((e) => throwError(e)),
    )
    .subscribe(
      (data) => {
        // 正常系の場合
        if (data.return_cd === '000') {
          // お知らせ一覧をセット
          this.list = data;
          return;
        }

        // ログインが必要な場合、Yログインへ飛ばす
        if (data.error.is_login) {
          this.loginService.sendLogin(data.error.move_to);
          return;
        }

        switch (data.error.return_cd) {
          case '400': this.error = this.errorService.getErrorMessage('02-01'); break;
          case '500': this.error = this.errorService.getErrorMessage('02-04'); break;
          case '501': this.error = this.errorService.getErrorMessage('02-05'); break;
          case '502': this.error = this.errorService.getErrorMessage('02-06'); break;
          default: this.error = this.errorService.getErrorMessage('02-01'); break;
        }
      },
      (error) => {
        this.error = this.errorService.getErrorMessage((error.status === 500) ? '02-03' : '01-01');
      },
    );

    // GTM送信
    if (this.gtmService.visited) {
      this.gtmService.sendPv();
    }

    // アクセスフラグ
    if (!this.gtmService.visited) {
      this.gtmService.visited = true;
    }
  }

  onClickLink(e:Event,href:string){
    if(this.tAppService.isTappAndVersionCheck(3,5,0)){
      e.preventDefault();
      
      try{
        this.tAppService.openView(href) 
      } catch (_) {}
    }
    
  }
}
